// Using Vue 3 reactive system
import { reactive } from 'vue';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type EventCallback = (...args: any[]) => void;

interface EventBusInterface {
  emit(event: string, ...args: unknown[]): void;
  on(event: string, callback: EventCallback): void;
  off(event: string, callback: EventCallback): void;
  [event: string]: unknown;
}

const EventBus = reactive<EventBusInterface>({
  emit(event, ...args) {
    const callbacks = this[event] as EventCallback[] | undefined;
    if (callbacks) {
      callbacks.forEach((callback) => callback(...args));
    }
  },
  on(event, callback) {
    if (!this[event]) {
      this[event] = [];
    }
    (this[event] as EventCallback[]).push(callback);
  },
  off(event, callback) {
    if (this[event]) {
      const callbacks = this[event] as EventCallback[];
      const index = callbacks.indexOf(callback);
      if (index > -1) {
        callbacks.splice(index, 1);
      }
    }
  },
});

export default EventBus;
